(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // This is js for header menu
    const toggle = document.getElementById('toggle');
    const overlay = document.getElementById('overlay');
    const logo = document.querySelector('.header .logo');
    const btnHelp = document.querySelector('.header .btn-help');

    function toggleMenu() {
      toggle.classList.toggle('is-active');
      overlay.classList.toggle('open');
      logo.classList.toggle('is-active');
      btnHelp.classList.toggle('is-active');
    }

    function openMenu() {
      toggle.classList.add('is-active');
      overlay.classList.add('open');
      logo.classList.add('is-active');
      btnHelp.classList.add('is-active');
    }

    toggle && toggle.addEventListener('click', toggleMenu);

    // check if query string contains 'menu=open' to open the menu
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('menu') === 'open') {
      openMenu();
      console.log('menu open');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-steps"]) return;
  try {
    
  const TargetMapping = {
    INTRO: 'intro',
    PREV: 'prev',
    NEXT: 'next',
    OUTRO: 'outro',
  };

  function updateViewHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  function generateStepProgress() {
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionSteps) return;
    const steps = sectionSteps.querySelectorAll('.block-screen[data-step]');
    const numberOfSteps = Array.from(steps).reduce((acc, step) => {
      return step.dataset.step > acc ? Number(step.dataset.step) : acc;
    }, 0);
    sectionSteps.dataset.blocks = steps.length;
    sectionSteps.style.setProperty('--blocks', steps.length);
    sectionSteps.dataset.activeBlock = numberOfSteps > 0 ? 1 : 0;
    sectionSteps.style.setProperty('--current-active-block', 1);
    steps.forEach((step, stepIdx) => {
      // Set data block id for step
      step.dataset.blockId = stepIdx + 1;
      const currentStep = Number(step.dataset.step);
      const progressBar = step.querySelector('.steps-progress-bar');
      if (!progressBar) return;
      progressBar.innerHTML = '';
      const stepElements = new Array(numberOfSteps + 1).fill(0);
      stepElements.forEach((_, index) => {
        const stepElement = document.createElement('div');
        stepElement.classList.add('step');
        const stepNumberElement = document.createElement('span');
        stepNumberElement.classList.add('step-progress-number');
        stepNumberElement.innerText = index + 1;
        stepElement.appendChild(stepNumberElement);
        sectionSteps.querySelectorAll(`.block-screen[data-step="${index + 1}"]`).forEach((video) => {
          if (video.classList.contains('step-motivation')) {
            const stepVideoElement = document.createElement('div');
            stepVideoElement.classList.add('step-progress-video', 'step-progress-motivation');
            stepElement.appendChild(stepVideoElement);
          } else {
            const stepVideoElement = document.createElement('span');
            stepVideoElement.classList.add('step-progress-video');
            stepElement.appendChild(stepVideoElement);
          }
        });
        if (index + 1 < currentStep) {
          stepElement.classList.add('is-done');
        } else if (index + 1 === currentStep) {
          stepElement.classList.add('is-current');
        } else if (index === numberOfSteps) {
          stepElement.classList.add('is-final');
        }
        progressBar.appendChild(stepElement);
      });
      progressBar.querySelectorAll('.step-progress-video').forEach((stepVideoElement, stepVideoIdx) => {
        if (stepVideoIdx < stepIdx) {
          stepVideoElement.classList.add('is-done');
        } else if (stepVideoIdx === stepIdx) {
          stepVideoElement.classList.add('is-current');
        }

        // add to element click function to call goToBlock with property of current index
        stepVideoElement.addEventListener('click', () => {
          goToBlock(stepVideoIdx + 1);
        });
      });
    });
  }

  function generateOutroProgress() {
    const sectionOutro = document.querySelector('.experience-outro');
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionOutro || !sectionSteps) return;
    const progressBar = sectionSteps.querySelector('.steps-progress-bar');
    const progressBarOutro = sectionOutro.querySelector('.steps-progress-bar');

    const newProgressBar = progressBar.cloneNode(true);

    newProgressBar.querySelectorAll('.is-current, .is-done').forEach((element) => {
      element.classList.remove('is-current', 'is-done');
    });
    newProgressBar.querySelectorAll('.step').forEach((step) => {
      if (step.classList.contains('is-final')) {
        step.classList.add('is-current');
      } else {
        step.classList.add('is-done');
      }
    });

    progressBarOutro.parentNode.replaceChild(newProgressBar, progressBarOutro);
  }

  function handleStepTransition(target) {
    switch (target) {
      case TargetMapping.PREV:
        goToPrevStep();
        break;
      case TargetMapping.NEXT:
        goToNextStep();
        break;
      default:
        break;
    }
  }

  function restartSteps() {
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionSteps) return;
    const header = document.querySelector('.experience-header');
    const btnPrev = sectionSteps.querySelector(".action-btn[data-target='prev']");
    const btnNext = sectionSteps.querySelector(".action-btn[data-target='next']");

    sectionSteps.classList.remove('is-motivation');
    sectionSteps.dataset.activeBlock = 1;
    sectionSteps.style.setProperty('--current-active-block', 1);
    header.classList.remove('is-hidden');
    btnPrev.disabled = false;
    btnPrev.className = 'action-btn btn-prev';
    btnNext.disabled = false;
    btnNext.className = 'action-btn btn-next';
  }

  function goToBlock(blockId) {
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionSteps) return;
    const numberOfBlocks = Number(sectionSteps.dataset.blocks || 1);
    const header = document.querySelector('.experience-header');
    const btnPrev = sectionSteps.querySelector(".action-btn[data-target='prev']");
    const btnNext = sectionSteps.querySelector(".action-btn[data-target='next']");

    const currentStep = sectionSteps.querySelector('.block-screen.is-active');
    if (currentStep) {
      deactiveTarget(currentStep);
    }

    // before navigating to another block, we stop all running videos
    // (so we dont have anything running in the background)
    const allVideosInThePage = document.querySelectorAll('.video iframe');
    allVideosInThePage.forEach(function (elm) {
      elm.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    });

    setTimeout(() => {
      sectionSteps.dataset.activeBlock = blockId;
      sectionSteps.style.setProperty('--current-active-block', blockId);
      const blockTarget = sectionSteps.querySelector(`.block-screen[data-block-id="${blockId}"]`);
      blockTarget.classList.add('is-active');
      hasVerticalScrollbar(blockTarget.querySelector('.screen-description'));
      handleStepProgressScroll(blockTarget);
      if (blockTarget.classList.contains('step-motivation')) {
        sectionSteps.classList.add('is-motivation');
        header.classList.add('is-hidden');
        btnPrev.disabled = false;
        btnNext.disabled = false;
        btnNext.classList.remove('btn-next');
      } else {
        sectionSteps.classList.remove('is-motivation');
        header.classList.remove('is-hidden');
        btnPrev.disabled = false;
        btnNext.disabled = false;
        btnNext.classList.add('btn-next');
      }
    }, 500);
  }

  function goToPrevStep() {
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionSteps) return;
    const currentActiveId = Number(sectionSteps.dataset.activeBlock || 1);
    if (currentActiveId === 1) {
      deactiveTarget(sectionSteps);
      setTimeout(() => {
        activeTarget(TargetMapping.INTRO);
      }, 500);
      return;
    }
    goToBlock(currentActiveId - 1);
  }

  function goToNextStep() {
    const sectionSteps = document.querySelector('.experience-steps');
    if (!sectionSteps) return;
    const currentActiveId = Number(sectionSteps.dataset.activeBlock || 1);
    const numberOfBlocks = Number(sectionSteps.dataset.blocks || 1);
    if (currentActiveId < numberOfBlocks) {
      goToBlock(currentActiveId + 1);
    } else {
      deactiveTarget(sectionSteps);
      setTimeout(() => {
        activeTarget(TargetMapping.OUTRO);
        restartSteps();
        handleStepProgressScroll(document.querySelector(`.shopify-section.experience-${TargetMapping.OUTRO}`));
      }, 500);
    }
  }

  function handleTransition() {
    const actionButtons = document.querySelectorAll('.action-btn[data-target], .experience-intro .teacher');
    if (!actionButtons) return;
    actionButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const target = btn.dataset.target;
        if (!target) return;
        if (target === TargetMapping.PREV || target === TargetMapping.NEXT) {
          handleStepTransition(target);
          return;
        }
        const currentSection = btn.closest('.section-with-actions');
        deactiveTarget(currentSection);
        setTimeout(() => {
          // if (target === TargetMapping.OUTRO) {
          //   restartSteps();
          // }
          activeTarget(target);
        }, 500);
      });
    });
  }

  /**
   * This function activates a target element by adding the 'is-active' class to it.
   * The target element is identified by its 'data-active' attribute which should match the provided target string.
   *
   * @param {string} target
   */
  function activeTarget(target) {
    const targetElement = document.querySelector(`.shopify-section.experience-${target}`);
    if (!targetElement) return;
    targetElement.classList.add('is-active');
    if (targetElement.querySelector('.block-screen')) {
      targetElement.querySelector('.block-screen').classList.add('is-active');
      hasVerticalScrollbar(targetElement.querySelector('.block-screen .screen-description'));
    }
  }

  /**
   * This function deactivates a element by removing the 'is-active' class from it.
   *
   * @param {HTMLElement} target
   */
  function deactiveTarget(target) {
    if (!target) return;
    target.setAttribute('hidding', '');
    target.addEventListener(
      'animationend',
      () => {
        target.removeAttribute('hidding');
        target.classList.remove('is-active');
        if (target.querySelector('.block-screen.is-active')) {
          target.querySelector('.block-screen.is-active').classList.remove('is-active');
        }
      },
      { once: true }
    );
  }

  function hasVerticalScrollbar(element) {
    if (!element) return;
    if (element.scrollHeight > element.clientHeight) {
      element.classList.add('has-scrollbar');
    }
  }

  function handleStepProgressScroll(block) {
    if (!block) return;
    const stepProgressWrapper = block.querySelector('.steps-progress-wrapper');
    if (!stepProgressWrapper) return;
    const doneStep = stepProgressWrapper.querySelectorAll('.step.is-done');
    if (doneStep.length === 0) return;
    let distance = 0;
    doneStep.forEach((step) => {
      distance += step.offsetWidth;
    });
    stepProgressWrapper.scrollLeft += distance;
  }

  document.addEventListener('DOMContentLoaded', (e) => {
    updateViewHeight();
    window.addEventListener('resize', updateViewHeight);

    generateStepProgress();
    generateOutroProgress();
    handleTransition();
  });

  } catch(e) { console.error(e); }
})();
})();
